import type { MagicEdenAuctionHouseOfferRef } from "@anaconda/core/bid/types"
import type { Nft } from "@anaconda/core/nft/types"
import { sonnerToast } from "@rarible_int/anaconda_ui_components"
import { useMolecule } from "bunshi/react"
import { useCallback, useMemo } from "react"
import { getTransactionErrorMessage } from "../events/transaction-event"
import { SolanaAcceptMagicEdenOfferMoleculeReatom } from "./solana-accept-magic-eden-offer-molecule.reatom"

export function useSolanaAcceptMagicEdenOffer() {
  const { acceptMagicEdenOfferActionFactory } = useMolecule(
    SolanaAcceptMagicEdenOfferMoleculeReatom,
  )
  const acceptAction = useMemo(
    () => acceptMagicEdenOfferActionFactory(),
    [acceptMagicEdenOfferActionFactory],
  )

  const mutate = useCallback(
    (params: { nft: Nft; offer: MagicEdenAuctionHouseOfferRef }) => {
      void (async () => {
        try {
          await acceptAction(params).catch(() => undefined)
        } catch (error) {
          sonnerToast.error(getTransactionErrorMessage(error))
        }
      })()
    },
    [acceptAction],
  )

  return {
    mutate,
    isPending: !!acceptAction.pending(),
  }
}
